import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "teacher-info-container" }
const _hoisted_2 = { class: "info-card" }

import { onMounted, ref } from 'vue'
import { useUserStore } from "@/store";
import { putUserDetailApi } from "@/servers/api/user";
import { teacher_info } from "@/views/teacher/types";
import { message, Modal, type DescriptionsProps } from "ant-design-vue";
import {useLogout} from "@/composables/useLogout";
import { getClassesApi, getClassesDetailApi, putClassesDetailApi } from '@/servers/api/classes';


export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherInfo',
  setup(__props) {

const user = useUserStore();
const show = ref<teacher_info>({
  bindState: false,
  email: '暂无',
  role: '未绑定',
  username: '暂无',
  class_id: '未绑定',
  school_id: '暂无',
  phone: '暂无',
  subject: '暂无',
  name: '暂无'
});
const class_list = ref<{ name: string; value: string }[]>([]);
const open = ref<boolean>(false);
const loading = ref<boolean>(false);
const {logout} = useLogout();

onMounted(async () => {
  const teacher_info = user.getUserInfo();

  // 获取班级列表
  const r = await getClassesApi({});
  class_list.value = r.data.map((class_info:any) => ({name:class_info.name,value:class_info.id})); // 要加[]
  if (teacher_info.bind_state) {
    show.value = {
      bindState: teacher_info.bind_state,
      email: teacher_info.email || '暂无',
      role: teacher_info.role || '未绑定',
      username: teacher_info.name || '暂无',
      school_id: teacher_info.teacher.school_id || '暂无',
      phone: teacher_info.phone || '暂无' ,
      subject: teacher_info.teacher.subject || '暂无',
      name: teacher_info.teacher.name || '暂无',
      class_id: '未绑定',
    };
  }else{
    show.value.bindState = teacher_info.bind_state;
    show.value.email = teacher_info.email || '暂无';
    show.value.username = teacher_info.name || '暂无';
    show.value.phone = teacher_info.phone || '暂无'
  }
  const re = await getClassesApi({ header: teacher_info.role });
  console.log("re", re)
  if (re.code === 200) {
    show.value.class_id = re.data[0].id;
  } else {
    message.error(re.data || '获取班级信息失败');
  }
});

const showModifyModal = () => {
  open.value = true;
};

const handleOk = async () => {
  loading.value = true;
  try {
    const info = user.getUserInfo();
    const res = await putUserDetailApi({ user_id: String(info.id) }, {
      email: show.value.email,
      phone: show.value.phone,
      name: show.value.username,
      bind_state: true
    });

    if (res.code !== 200) {
      message.error(res.data || '绑定失败');
      return 
    }

    // 修改班级表的班主任为该教师
    const r = await getClassesDetailApi({ class_id: Number(show.value.class_id) });
    if (r.code === 200) {
      const params = {
        class_id: show.value.class_id,
        header : show.value.role
      }
      const data = r.data[0]
      const re = await putClassesDetailApi(
        { class_id: Number(params.class_id) }, 
        { 
          header: params.header, 
          name: data.name || data.id, 
          school_id: data.school_id || '', 
          subject_selection: data.subject_selection || '' }
      );
      if (re.code === 200) {
        message.success('修改班级信息成功');
      } else {
        message.error(re.data || '修改班级信息失败');
      }
    }else {
      message.error(r.data || '修改班级信息失败');
    }
  } catch (error) {
    message.error('绑定过程中出现错误');
  } finally {
    loading.value = false;
  }
};

const unbind = async () => {
  const info = user.getUserInfo();
  // 添加确认弹窗
  Modal.confirm({
    title: '确认解除绑定',
    content: '您确定要解除教师绑定吗？解除绑定后将无法查看相关教学信息。',
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const res = await putUserDetailApi({ user_id: String(info.id) }, {
          email: show.value.email,
          phone: show.value.phone,
          name: show.value.username,
          role: '',
          bind_state: false
        });

        if (res.code === 200) {
          message.success('解除绑定成功')
          await logout()
        } else {
          message.error(res.data || '解除绑定失败');
        }
      } catch (error) {
        message.error('解除绑定过程中出现错误');
      }
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h2", null, "教师信息"),
      _createElementVNode("p", null, "查看和管理您的教师账户信息")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_card, {
        title: "",
        class: "teacher-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_descriptions, {
            bordered: "",
            column: { xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 },
            size: "middle"
          }, {
            extra: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  (show.value.bindState)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "dashed",
                        onClick: unbind,
                        class: "unbind-button"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("解除绑定", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: showModifyModal,
                    class: "bind-button"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("绑定信息", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, { label: "教师姓名" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(show.value.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "学校" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(show.value.school_id), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "任教学科" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(show.value.subject), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "用户账号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(show.value.email), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "联系方式" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(show.value.phone), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "工号" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(show.value.role), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "绑定状态" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(show.value.bindState ? 'status-bound' : 'status-unbound')
                  }, _toDisplayString(show.value.bindState ? '已绑定' : '未绑定'), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "班级" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(show.value.class_id), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((open).value = $event)),
      title: "修改信息",
      onOk: handleOk,
      "confirm-loading": loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "用户名" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: show.value.username,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((show.value.username) = $event)),
                  placeholder: "请输入用户名"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "班级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: show.value.class_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((show.value.class_id) = $event)),
                  placeholder: "请选择班级"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(class_list.value, (value) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: value.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(value.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "联系方式" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: show.value.phone,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((show.value.phone) = $event)),
                  placeholder: "请输入联系方式"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "confirm-loading"])
  ]))
}
}

})